export const PROVIDERS_ES = [
  { id: 'urbancampus', name: 'Urban Campus' },
  { id: 'gaiastays', name: 'GaiaStays' },
  { id: 'kanso', name: 'Kanso Coliving' },
  { id: 'muppy', name: 'Muppy' },
  { id: 'enso', name: 'Enso Coliving' },
  { id: 'homiii', name: 'Homiii' },
  { id: 'spacest', name: 'Spacest' },
  { id: 'aticco', name: 'Aticco Living' },
  { id: 'haaus', name: 'Haaus' },
  { id: 'socien', name: 'Socien' },
  { id: 'suiters', name: 'Suiters' },
  { id: 'houxury', name: 'Houxury' },
  { id: 'colivinn', name: 'ColivINN' },
  { id: 'trc', name: 'The Residential Club' },
  { id: 'node', name: 'Node Living' },
  { id: 'colive', name: 'Colive' },
  { id: 'trees', name: 'Trees Coliving' },
  { id: 'flipco', name: 'Flipco Living' },
  { id: 'liveit', name: 'Live it (SmartRental)' },
  { id: 'habyt', name: 'Habyt' },
  { id: 'queens', name: 'Queens Coliving' },
  { id: 'socialhub', name: 'The Social Hub' },
  { id: 'outsite', name: 'Outsite' },
  { id: 'blueground', name: 'Blueground' },
  { id: 'mycoliving', name: 'MyCO Living' },
  { id: 'becasa', name: 'Be Casa Essential' },
  { id: 'oceanika', name: 'Oceanika (Habyt)' },
  { id: 'nova', name: 'Nova Málaga (Estudiantes)' },
  { id: 'alegoria', name: 'Alegoría Coliving' },
  { id: 'olivar', name: 'Olivar Plaza Cohousing' },
  { id: 'resa', name: 'RESA (Estudiantes)' },
  { id: 'yugo', name: 'Yugo (Estudiantes)' },
  { id: 'livensa', name: 'Livensa Living (Estudiantes)' },
  { id: 'collegiate', name: 'Collegiate (Estudiantes)' },
  { id: 'thestart', name: 'The Start' },
  { id: 'aspasios', name: 'Aspasios Boutique Apartments' },
  { id: 'flaternity', name: 'Flaternity' },
  { id: 'hive', name: 'Grupo Hive' },
  { id: 'nomad', name: 'Nomad Flex Living' },
  { id: 'farhome', name: 'Far Home' },
  { id: 'repeople', name: 'Repeople' },
  { id: 'maraya', name: 'Maraya Coliving' }
];

export const PROVIDERS_US = [
  { id: 'junehomes', name: 'June Homes' },
  { id: 'furnishedquarters', name: 'Furnished Quarters' },
  { id: 'fllat', name: 'Fllat' },
  { id: 'aya', name: 'Hello AYA' },
  { id: 'cohabs', name: 'Cohabs' },
  { id: 'outpost', name: 'Outpost' },
  { id: 'roomrs', name: 'Roomrs' },
  { id: 'node', name: 'Node Living NYC' },
  { id: 'silverman', name: 'Silverman Building' },
  { id: 'reserve', name: 'The Reserve NYC' },
  { id: 'squarelivinghub', name: 'The Square Living Hub' },
  { id: 'blueground', name: 'Blueground' }
];

export const PROVIDERS_UK = [
  { id: 'arkliving', name: 'ARK Living' },
  { id: 'gravityco', name: 'Gravity Co' },
  { id: 'folkcoliving', name: 'Folk Coliving' },
  { id: 'masonfifth', name: 'Mason & Fifth' },
  { id: 'cohabslondon', name: 'Cohabs London' },
  { id: 'nodelondon', name: 'Node Living London' },
  { id: 'quintainliving', name: 'Quintain Living' },
  { id: 'scape', name: 'Scape Student' },
  { id: 'canvas', name: 'Canvas Accommodation' },
  { id: 'lyvly', name: 'Lyvly' },
  { id: 'fizzyliving', name: 'Fizzy Living' },
  { id: 'yourtribe', name: 'YourTRIBE' },
  { id: 'uncle', name: 'UNCLE' },
  { id: 'dandi', name: 'Dandi Living' },
  { id: 'iq', name: 'iQ Student' },
  { id: 'unite', name: 'Unite Students' },
  { id: 'bloom', name: 'Bloom Coliving' },
  { id: 'bamboo', name: 'Bamboo Living' },
  { id: 'stayclub', name: 'The Stay Club' },
  { id: 'coluxliving', name: 'Co-Lux Living' },
  { id: 'thecollective', name: 'The Collective' },
  { id: 'studentroost', name: 'Student Roost' },
  { id: 'domicoliving', name: 'Domi Coliving' },
  { id: 'chapter', name: 'Chapter Living' },
  { id: 'vonder', name: 'Vonder' },
  { id: 'aparto', name: 'aparto' },
  { id: 'blueground', name: 'Blueground' }
];
